import { useNavigate, Link } from "react-router-dom";
import { useState } from 'react';
import Footer from "../Pages/Footer";
import toast, { Toaster } from 'react-hot-toast';
import { API_URL } from '../config/api';

export default function Register({ onRegister }) {
  const [name, setName] = useState("");
  const [surname, setSurname] = useState("");
  const [address, setAddress] = useState("");
  const [ville, setVille] = useState("");
  const [number, setNumber] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [password2, setPassword2] = useState("");
  const [error, setError] = useState(null);

  const navigate = useNavigate();

  const handleRegister = async (e) => {
    e.preventDefault();

    if (password !== password2) {
      setError("Les mots de passe ne correspondent pas.");
      return;
    }

    const formData = new FormData();
    formData.append("name", name);
    formData.append("surname", surname);
    formData.append("address", address);
    formData.append("ville", ville);
    formData.append("number", number);
    formData.append("email", email);
    formData.append("password", password);
    formData.append("password2", password2);

    try {
      const res = await fetch(`${API_URL}/user/register`, {
        method: "POST",
        body: formData,
      });

      const userData = await res.json();

      if (!res.ok) {
        setError(userData.message || "Inscription échouée");
        return;
      }

      localStorage.clear();
      localStorage.setItem("user", JSON.stringify(userData.user));
      if (onRegister) onRegister(userData.user);

      toast.success("Inscription réussie !", { duration: 4000 });
      navigate('/login');
    } catch (err) {
      console.error(err);
      setError("Erreur serveur lors de l'inscription");
    }
  };

  return (
    <>
    <div className="register-page">
      <Toaster position="top-right" reverseOrder={false} />
      <div className="register-container">
        <div className="register-card">
          <h2 className="register-header">Créer mon compte</h2>
          {error && <p className="register-error">{error}</p>}

          <form onSubmit={handleRegister} className="register-form">
            <input type="text" placeholder="Nom" value={name} onChange={e => setName(e.target.value)} required />
            <input type="text" placeholder="Prénom" value={surname} onChange={e => setSurname(e.target.value)} required />
            <input type="text" placeholder="Adresse" value={address} onChange={e => setAddress(e.target.value)} required />
            <input type="text" placeholder="Ville" value={ville} onChange={e => setVille(e.target.value)} required />
            <input type="tel" placeholder="Numéro de téléphone" value={number} onChange={e => setNumber(e.target.value)} required />
            <input type="email" placeholder="Email" value={email} onChange={e => setEmail(e.target.value)} required />
            <input type="password" placeholder="Mot de passe" value={password} onChange={e => setPassword(e.target.value)} required />
            <input type="password" placeholder="Confirmation du mot de passe" value={password2} onChange={e => setPassword2(e.target.value)} required />

            <button type="submit" className="btn-register">Inscription</button>
          </form>

          <p className="register-footer">
            Déjà un compte ? <Link to="/login" className="link-login">Se connecter</Link>
          </p>
        </div>
      </div>
      

      <style jsx>{`
        .register-page {
          min-height: 100vh;
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          // background: linear-gradient(135deg, #667eea, #764ba2);
          padding: 2rem;
        }
        .register-container {
          width: 100%;
          max-width: 400px;
        }
        .register-card {
          background: #fff;
          padding: 2rem;
          border-radius: 1rem;
          box-shadow: 0 10px 25px rgba(0,0,0,0.1);
          display: flex;
          flex-direction: column;
          gap: 1rem;
        }
        .register-header {
          text-align: center;
          font-size: 1.8rem;
          font-weight: 700;
          color: #333;
          margin-bottom: 1rem;
        }
        .register-error {
          color: #ff4d4f;
          text-align: center;
          font-weight: 500;
        }
        .register-form input {
          width: 100%;
          padding: 0.75rem 1rem;
          border: 1px solid #ddd;
          border-radius: 0.75rem;
          font-size: 1rem;
          margin-bottom: 1rem;
          outline: none;
          transition: all 0.2s ease;
        }
        .register-form input:focus {
          border-color: #667eea;
          box-shadow: 0 0 0 2px rgba(102, 126, 234, 0.2);
        }
        .btn-register {
          width: 100%;
          padding: 0.75rem;
          background: #667eea;
          color: #fff;
          font-weight: 600;
          border: none;
          border-radius: 0.75rem;
          cursor: pointer;
          transition: all 0.2s ease;
        }
        .btn-register:hover {
          background: #5563d6;
        }
        .register-footer {
          text-align: center;
          margin-top: 1rem;
        }
        .link-login {
          color: #667eea;
          font-weight: 600;
          text-decoration: none;
        }
        .link-login:hover {
          text-decoration: underline;
        }
      `}</style>
    </div>
    <Footer />
    </>
  );
}